export default {
  login: {
    phonename: "蘑菇云手机",
    title: "欢迎使用蘑菇云手机",
    login: "登录",
    registered: "注册",
    forgotPassword: "忘记密码"
  },
  reg: {
    reg: "欢迎注册蘑菇云手机",
    findPass: "找回密码",
    haveUser: "已有账号",
    backLogin: "返回登录",
    mesCode: "获取验证码"
  },
  index: {
    title: "蘑きのこ雲菇云",
    buy: "ご注文/おかわり",
    integral: "积分/优惠券",
    defName: "蘑菇云用户",
    userMan: "账户管理",
    activationCode: "激活码",
    buyRecord: "订购记录",
    logout: "退出登录",
    userInfo: "个人信息",
    eidtPass: "修改密码",
    olaPass: "原密码",
    newPass: "新密码",
    confPass: "确认密码",
    exchangeCode: "兑换码",
    selectPhone: "选择云手机",
    addPhone: "新增云手机",
    exchangeDescTit: "兑换说明",
    exchangeDesc1: "每个激活码只能激活一次;",
    exchangeDesc2:
      "若你通过非官方渠道获取的激活码，无法激活，蘑菇云将概不负责;",
    exchangeDesc3: "该激活码最终解释权归蘑菇云所有;",
    nowExchange: "立即兑换",
    exchangeRecord: "兑换记录",
    myEq: "私の設備",
    appNav: "上传应用",
    feilNav: "上传文件",
    serNav: "扩展服务",
    time: "剩余时间"
  },
  pad: {
    resource: "品牌",
    group: "パケット増減クラウド",
    addGroup: "加入此分组",
    goNoGroup: "移至待分组",
    moveGroup: "分组间移动",
    goToGroup: "移动至分组",
    appOp: "应用安装/卸载",
    allSelect: "全选",
    noSelect: "反选",
    muchOp: "批量操作",
    rebPhone: "重启云机",
    reSetPhone: "恢复出厂设置",
    changeIp: "切换IP代理",
    syncPhone: "云机同步",
    live: "多路实时直播",
    changeRotateTrue: "切换横屏",
    changeRotateFalse: "切换竖屏",
    setSize: "150%大小",
    setSize1: "标准大小",
    setSize2: "75%大小",
    setSize3: "60%大小",
    setSize4: "50%大小",
    refresh: "刷新",
    loading: "加载中...",
    syncing: "应用同步中...",
    noPad: "暂无云机",
    noMore: "没有更多了",
    replacement: "一键换机",
    name: "云手机",
    phoneName: "云机名称",
    offline: "连接已断开，请关闭后重新连接！",
    linking: "连接中...",
    menuTit: "多任务",
    homeTit: "Home键",
    backTit: "返回键",
    screenshotsTit: "屏幕截图",
    voiceTit: "音量键",
    voiceUp: "音量加",
    voiceDown: "音量减",
    clipboardTit: "剪贴板",
    rotateTit: "横竖屏",
    hd: "高清",
    ordinary: "普通",
    highSpeed: "高速",
    speed: "极速",
    state: "状态",
    expireT: "到期时间",
    apkNum: "应用安装数",
    apkMan: "应用管理",
    apkInstall: "已安装应用",
    changeApkInstall: "请勾选需安装的应用"
  },
  label: {
    phone: "手机号码",
    pic: "图形验证码",
    mesCode: "短信验证码",
    pass: "登录密码",
    inviteCode: "邀请码"
  },
  form: {
    phone: "请输入手机号",
    checkPhone: "请输入正确的手机号",
    noPhone: "该手机号码没有注册！",
    yesPhone: "该手机号号码已经注册！",
    defUser: "请输入手机号，默认作为登录账号",
    password: "请输入登录密码",
    oldpassword: "请输入原密码",
    newPass: "请输入新密码",
    checkNewPass: "请再次输入新密码",
    pic: "请输入图形验证码",
    checkPass: "密码为8-20位数字和英文字母组成!",
    againPass: "新密码与旧密码不可一致！",
    nickName: "昵称",
    email: "邮箱",
    titEmail: "请输入邮箱地址",
    checkEmail: "请输入正确的邮箱地址",
    code: "请输入激活码，不区分大小写",
    nullCode: "激活码不能为空！",
    checkCode: "激活码格式错误！",
    mesCode: "请输入短信验证码",
    inviteCode: "请输入邀请码",
    content: "请输入内容",
    pSelect: "请选择",
    changeRtmp: "选择RTMP URL",
    noBuyRtmp: " 您还未购买多路实时直播RTMP URL！",
    codeHasUsed: "该激活码已使用",
    codeHasExpired: "该激活码已过期"
  },

  but: {
    confEdit: "确认修改",
    cancel: "取 消",
    yes: "确 定",
    empty: "清空"
  },
  mes: {
    logSu: "登陆成功",
    picEr: "上传图片尺寸过大！",
    eidtSu: "修改成功",
    eidSuLo: "修改成功,请重新登录",
    exchangeSu: "兑换成功，您兑换的云机将在5分钟内到账，请稍后查看",
    readyArgee: "我已阅读并同意",
    mogu1: "《蘑菇云隐私政策》",
    mogu2: "《蘑菇云服务协议》",
    and: "和",
    mesCodeSu: "获取验证码成功",
    regSu: "注册成功",
    findPassSu: "找回密码成功",
    copyTie: "近期复制或剪切过得文字",
    nullClipboard: "剪切板为空"
  },
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "クリア"
    },
    datepicker: {
      now: "現在",
      today: "今日",
      cancel: "キャンセル",
      clear: "クリア",
      confirm: "OK",
      selectDate: "日付を選択",
      selectTime: "時間を選択",
      startDate: "開始日",
      startTime: "開始時間",
      endDate: "終了日",
      endTime: "終了時間",
      prevYear: "前年",
      nextYear: "翌年",
      prevMonth: "前月",
      nextMonth: "翌月",
      year: "年",
      month1: "1月",
      month2: "2月",
      month3: "3月",
      month4: "4月",
      month5: "5月",
      month6: "6月",
      month7: "7月",
      month8: "8月",
      month9: "9月",
      month10: "10月",
      month11: "11月",
      month12: "12月",
      // week: '週次',
      weeks: {
        sun: "日",
        mon: "月",
        tue: "火",
        wed: "水",
        thu: "木",
        fri: "金",
        sat: "土"
      },
      months: {
        jan: "1月",
        feb: "2月",
        mar: "3月",
        apr: "4月",
        may: "5月",
        jun: "6月",
        jul: "7月",
        aug: "8月",
        sep: "9月",
        oct: "10月",
        nov: "11月",
        dec: "12月"
      }
    },
    select: {
      loading: "ロード中",
      noMatch: "データなし",
      noData: "データなし",
      placeholder: "選択してください"
    },
    cascader: {
      noMatch: "データなし",
      loading: "ロード中",
      placeholder: "選択してください",
      noData: "データなし"
    },
    pagination: {
      goto: "",
      pagesize: "件/ページ",
      total: "総計 {total} 件",
      pageClassifier: "ページ目へ"
    },
    messagebox: {
      title: "メッセージ",
      confirm: "OK",
      cancel: "キャンセル",
      error: "正しくない入力"
    },
    upload: {
      deleteTip: "Delキーを押して削除する",
      delete: "削除する",
      preview: "プレビュー",
      continue: "続行する"
    },
    table: {
      emptyText: "データなし",
      confirmFilter: "確認",
      resetFilter: "初期化",
      clearFilter: "すべて",
      sumText: "合計"
    },
    tree: {
      emptyText: "データなし"
    },
    transfer: {
      noMatch: "データなし",
      noData: "データなし",
      titles: ["リスト 1", "リスト 2"],
      filterPlaceholder: "キーワードを入力",
      noCheckedFormat: "総計 {total} 件",
      hasCheckedFormat: "{checked}/{total} を選択した"
    },
    image: {
      error: "FAILED" // to be translated
    },
    pageHeader: {
      title: "Back" // to be translated
    },
    popconfirm: {
      confirmButtonText: "Yes", // to be translated
      cancelButtonText: "No" // to be translated
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/japan.js